import Adherent from "./Adherent";
import Children from "./Children";
import Contract from "./Contract";
import Spouse from "./Spouse";

const STEPS_KEYS = {
  CONTRACT: "CONTRACT",
  ADHERENT: "ADHERENT",
  SPOUSE: "SPOUSE",
  CHILDREN: "CHILDREN",
};

const STEPS = (props) => ({
  [STEPS_KEYS.CONTRACT]: Contract(props),
  [STEPS_KEYS.ADHERENT]: Adherent(props),
  [STEPS_KEYS.SPOUSE]: Spouse(props),
  [STEPS_KEYS.CHILDREN]: Children(props),
});

export default STEPS;
